import Checkbox from '@vromo/ui/components/Checkbox';
import Flex from '@vromo/ui/components/Flex';
import theme from '@vromo/ui/components/theme';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './fleetOptionListItem.style';

interface Props {
    fleetName: string;
    coveragePercentageLabel: string;
    isChecked: boolean;
    onDetailsClicked: () => void;
    onToggleCoverageOption: (name: string) => void;
}

const FleetOptionListItem = ({
    fleetName,
    coveragePercentageLabel,
    isChecked,
    onDetailsClicked,
    onToggleCoverageOption
}: Props) => {
    const { t } = useTranslation();
    const coverageIcon = require('../../../../assets/coverage_icon.png');
    return (
        <div
            style={{
                ...styles.fleetTableItem,
                border: `1px solid ${isChecked ? theme.tertiary : theme.grey}`
            }}>
            <Flex horizontal="between" vertical="middle">
                <Flex horizontal="left" vertical="middle" style={styles.tableItemContents}>
                    <div style={styles.checkboxContainer}>
                        <Checkbox
                            label={fleetName}
                            labelStyle={styles.checkboxLabel}
                            checkedColor={theme.tertiary}
                            onChange={() => onToggleCoverageOption(fleetName)}
                            checked={isChecked}
                        />
                    </div>
                </Flex>
                <img src={coverageIcon} width={20}></img>
                <span style={styles.coverage}>{coveragePercentageLabel}</span>
                <div style={styles.detailsButtonContainer as CSSProperties}>
                    <a onClick={onDetailsClicked} style={styles.detailsButton}>
                        {t('findFleets.viewDetails')}
                    </a>
                </div>
            </Flex>
        </div>
    );
};

export default FleetOptionListItem;
